import React from 'react'
import {withRouter} from 'react-router-dom'
import classNames from 'classnames'
import glossaryPages, { getDefaultPage } from '../glossary/pages'
// Components
import styles from './sidebar.module.scss'

function GlossarySidebar({ history, match }) {

  const page = match.params.page ?? getDefaultPage()

  const handleSectionClick = (page, def) => def
    ? history.push(`/glossary`)
    : history.push(`/glossary/${page}`)

  return (
    <div className={styles.root}>
      <p>
        <strong>Term types</strong>
      </p>
      <ul className={styles.menu}>
        { glossaryPages.map((item, i) => {
          return (
            <li
              key={`section-${i}`}
              title={item.name}
              onClick={() => handleSectionClick(item.id, item.default)}
            >
              <div className={classNames(
                  {[styles.dataE]: page === item.id && page === "data-element"},
                  {[styles.dataO]: page === item.id && page === "data-object"},
                  {[styles.dataT]: page === item.id && page === "data-type"},
                  {[styles.dataD]: page === item.id && page === "data-domain"},
                  {[styles.sampleV]: page === item.id && page === "sample-value"},
                  {[styles.dataElement]: item.id === "data-element"},
                  {[styles.dataObject]: item.id === "data-object"},
                  {[styles.dataType]: item.id === "data-type"},
                  {[styles.dataDomain]: item.id === "data-domain"},
                  {[styles.sampleValue]: item.id === "sample-value"}
                  )}>
                {item.name}
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )

}


export default withRouter(GlossarySidebar)